import React, { useEffect } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';

function NoAuthRoute({ component: Component, ...rest }) {
  const authToken = localStorage.getItem('accessToken');
  const { pathname } = useLocation();

  return (
    <Route
      {...rest}
      render={props =>
        !authToken || pathname == '/auth/sign-up' ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/home', state: { referer: props.location } }} />
        )
      }
    />
  );
}

export default NoAuthRoute;
